export default __webpack_public_path__ + "static/privacy-seals-d9be86a8c7c84bf0c212f15d8f2954ef.png";